"use client";

import { useEffect } from "react";
import { initTracking } from "@/initTracking";
import { eventPublisher } from "@/events";

export function TrackingInitializer() {
  useEffect(() => {
    // Initialize tracking on client-side only
    const setupTracking = async () => {
      try {
        // Add debug subscriber to log all events
        const unsubscribe = eventPublisher.subscribe((event) => {
          console.log("Event published:", event.type, event);
        });

        // Initialize tracking system
        await initTracking();
        console.log("Event tracking system initialized successfully");

        // Clean up debug subscriber when component unmounts
        return () => {
          unsubscribe();
        };
      } catch (error) {
        console.error("Failed to initialize event tracking:", error);
      }
    };

    setupTracking();
  }, []);

  // This component doesn't render anything
  return null;
}
